import { useLingui } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import Stack from '@/design_system/Stack';
import IconCheck from '@/icons/Check.svg';
import IconCross from '@/icons/Cross.svg';
import IconEdit from '@/icons/Edit.svg';

export const EditButton = ({ label, onClick }: { label: string; onClick: () => void }) => {
  return (
    <Button
      ariaLabel={label}
      tooltip={label}
      size="medium"
      variant="secondary"
      iconOnly
      onPress={onClick}
    >
      <IconEdit />
    </Button>
  );
};

export const SaveCancelButtons = ({
  onSave,
  onCancel,
  isSaving,
}: {
  onSave: () => void;
  onCancel: () => void;
  isSaving: boolean;
}) => {
  const { t } = useLingui();

  return (
    <Stack row gap="0.5rem">
      <SaveButton
        label={t({
          id: 'settings.save',
          message: 'Save',
        })}
        onClick={() => onSave()}
        isLoading={isSaving}
      />

      <CancelButton
        label={t({
          id: 'settings.cancel',
          message: 'Cancel',
        })}
        onClick={() => onCancel()}
      />
    </Stack>
  );
};

export const SaveButton = ({
  label,
  onClick,
  isLoading,
}: {
  label: string;
  onClick: () => void;
  isLoading: boolean;
}) => {
  return (
    <Button
      ariaLabel={label}
      tooltip={label}
      size="medium"
      variant="primary"
      iconOnly
      onPress={onClick}
      isLoading={isLoading}
    >
      <IconCheck />
    </Button>
  );
};

const CancelButton = ({ label, onClick }: { label: string; onClick: () => void }) => {
  return (
    <Button
      ariaLabel={label}
      tooltip={label}
      size="medium"
      variant="secondary"
      iconOnly
      onPress={onClick}
    >
      <IconCross />
    </Button>
  );
};
